import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Typography, Link } from "@bca/ui-library";

import KeyDecisionMakerContainer from "./KeyDecisionMakerContainer";
import StarRating from "./StarRating";
import { formatMoney } from "../components/buyingOptions/formatMoney";
import { KeyDecisionMakerText } from "./mechanicalReport/styledElements/KeyDecisionMakerText";

const StyledLink = styled(Link)`
  ${css({
    fontSize: "body-small",
    textAlign: "center",
    paddingRight: [10, 0],
  })}
`;

const HPISpecCheck: React.FunctionComponent<{
  starRating?: number | null;
  price: number | null;
  anchorLink?: string;
}> = ({ starRating, price, anchorLink }) => {
  if (price === null || price === undefined || !Boolean(starRating)) {
    return null;
  }

  return (
    <KeyDecisionMakerContainer>
      <KeyDecisionMakerText>
        <StarRating variant="small" rating={starRating.toFixed(1).toString()} />
        <Typography variant="h6" color="footer-blue" m={0}>{`${formatMoney(
          price
        )} extras`}</Typography>
      </KeyDecisionMakerText>
      {anchorLink && (
        <StyledLink
          href={anchorLink}
          color="primary-light-blue"
          underline="always"
          analytics={{
            eventLabel: "hpi-check",
            eventAction: "navigate",
            eventSection: "primary-information",
          }}
        >
          HPI Spec Check
        </StyledLink>
      )}
    </KeyDecisionMakerContainer>
  );
};

export default HPISpecCheck;
